module.exports = __webpack_public_path__ + "img/img2.5939b407.jpg";